import { render, staticRenderFns } from "./RestrictedSocialBookingDates.vue?vue&type=template&id=61902a03&"
import script from "./RestrictedSocialBookingDates.vue?vue&type=script&lang=js&"
export * from "./RestrictedSocialBookingDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports